import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button,
  useTheme,
} from '@mui/material';
import { makeStyles } from '@mui/styles';

const useStyles = makeStyles(() => ({
  contentText: {
    whiteSpace: 'pre-line' // This preserves line breaks in the text
  }
}));

const HomeDialog = ({ open, content, title, onClose }) => {
  const theme = useTheme();
  const classes = useStyles();

  const buttonStyle = {
    color: theme.palette.type === 'dark' ? '#fff' : '#000',
    backgroundColor: '#dec05d',
    '&:hover': {
      backgroundColor: '#bca74d',
    },
  };

  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>{title}</DialogTitle>
      <DialogContent>
        <DialogContentText className={classes.contentText}>{content}</DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} style={buttonStyle} fullWidth>
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default HomeDialog;
